<template>
  <div class="container">
    <div v-if="fitGradeList.length" class="flex-align-center" style="margin-bottom: 15px">
      <div style="margin-right: 15px">适用年级</div>
      <div>
        <a-checkable-tag
          class="tag-item"
          v-for="(item, index) in fitGradeList"
          :key="index"
          v-model="item.checked"
          @change="changeTag(item)"
        >
          {{ item.text }}
        </a-checkable-tag>
      </div>
    </div>
    <div v-if="categoryList.length" class="flex-align-center" style="margin-bottom: 15px">
      <div style="margin-right: 15px">
        分
        <span style="padding: 0 12px"></span>
        类
      </div>
      <div>
        <a-checkable-tag
          class="tag-item"
          v-for="(item, index) in categoryList"
          :key="index"
          v-model="item.checked"
          @change="(checked) => changeTag(item, checked)"
        >
          {{ item.text }}
        </a-checkable-tag>
      </div>
    </div>
    <EmptyData
      :dataSource="cardList"
      :loading="loading"
      :isSetPageCenter="true"
      :style-obj="{ minHeight: '60vh' }"
    >
      <a-row slot="content" :gutter="20">
        <a-col :span="4" v-for="(item, index) in cardList" :key="index" style="margin-bottom: 20px">
          <div class="card-box box-shadow-1" @click="cardClick(item)">
            <div class="cover">
              <img
                :src="$getStoreHttpUrl(item.cover)"
                alt="封面"
                style="width: 100%; height: 100%; object-fit: cover"
              />
            </div>
            <div class="text-content">
              <div class="title">{{ item.title }}</div>
              <div v-html="item.content" class="desc text-ellipsis-3"></div>
            </div>
          </div>
        </a-col>
      </a-row>
    </EmptyData>
    <!--    分页-->
    <a-pagination
      v-if="cardList.length"
      class="pagination"
      show-size-changer
      :total="total"
      @change="changePage"
      @showSizeChange="changePage"
    />
  </div>
</template>

<script>
export default {
  name: 'SchemeCard',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    cardList: {
      type: Array,
      default: () => [],
    },
    fitGradeList: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      allTotal: false,
    }
  },
  created() {
    console.log('页数：', this.total)
  },
  methods: {
    changeTag(item, checked) {
      console.log('选择标签：', item, checked)
      // console.log('categoryList', this.categoryList)
      // console.log('fitGradeList', this.fitGradeList)
    },
    cardClick(item) {
      console.log('卡片信息：', item)
      this.$emit('cardClick', item)
    },
    changePage(pageNo, pageSize) {
      console.log('分页信息：', pageNo, pageSize)
      this.$emit('refreshData', pageNo, pageSize)
    },
  },
}
</script>
<style scoped lang="less">
.container {
  position: relative;
  min-height: 82vh;
  padding: 0 8px;
  background: #fff;

  /deep/ .ant-tag-checkable {
    border: 1px solid #f1f1f1;
  }
  .pagination {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .tag-item {
    padding: 2px 16px;
  }
  .card-box {
    width: 100%;
    height: 270px;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
      border: 1px solid #00a1d6;
      transition: all 0.3s ease-in-out;
    }
    .cover {
      width: 100%;
      height: 140px;
      background: #eee;
    }
    .text-content {
      width: 100%;
      padding: 10px;
      .title {
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
      }
      .desc {
        width: 100%;
        font-size: 12px;
        line-height: 2;
        color: #a9afc0;
      }
    }
  }
}
</style>
